
export class QuestionReqModel {
    qnos: string;
    sectionId: number;
    className: number;
    language: number;
    subject: number;
    chapter: number;
    topic: number;
    difficultyLevel: number;
    questionType: number;
    weightage: number;
    noOfQns: number;
    subAbilityId?: number;
    constructor(
        className: number,
        language: number,
        subject: number,
        chapter: number,
        topic: number,
        difficultyLevel: number,
        questionType: number,
        weightage: number,
        noOfQns: number,
        subAbilityId?: number,
    ) {
        this.className = className;
        this.language = language;
        this.subject = subject;
        this.chapter = chapter;
        this.topic = topic;
        this.difficultyLevel = difficultyLevel;
        this.questionType = questionType;
        this.weightage = weightage;
        this.noOfQns = noOfQns;
        this.subAbilityId = subAbilityId;
    }
}

export class DifficultyDistribution {
    easy: number;
    moderate: number;
    difficult: number;

    constructor(easy = 0, moderate = 0, difficult = 0) {
        this.easy = easy;
        this.moderate = moderate;
        this.difficult = difficult;
    }
}